import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import SectionLoader from '../SectionLoader'
import TitledListItem from '../TitledListItem'
import Badge from 'js/components/shared/Badge'

import styles from './ArrivalAndDepartureSection.module.scss'

const cx = classnames.bind(styles);

const ArrivalAndDepartureSection = function ({
  isLoading,
  info = {},
  className = ''
}) {
  return (
    <div className={cx('root', className)}>
      {isLoading && (<SectionLoader />)}
      {!isLoading && (
        <ul className={cx('list')}>
          {info?.arrival && (
            <li>
              {info.arrival.checkinHour && (
                <TitledListItem title={info.arrival.checkinHour.label} tag="div" grouped>
                  <p>{info.arrival.checkinHour.hour}</p>
                </TitledListItem>
              )}
              {info.arrival.checkoutHour && (
                <TitledListItem title={info.arrival.checkoutHour.label} tag="div" grouped>
                  <p>{info.arrival.checkoutHour.hour}</p>
                </TitledListItem>
              )}
              {info.arrival.description && (
                <TitledListItem tag="div" grouped>
                  <p>{info.arrival.description}</p>
                </TitledListItem>
              )}
              {info.arrival.openingHours && (
                <TitledListItem title={info.arrival.openingHours.label} tag="div" grouped>
                  <p>{info.arrival.openingHours.hours}</p>
                </TitledListItem>
              )}
            </li>
          )}
          {!!info?.spokenLanguages?.list?.length && (
            <TitledListItem title={info.spokenLanguages.label}>
              <ul>
                {info.spokenLanguages.list.map((lang, i) => (<li key={i}>{lang}</li>))}
              </ul>
            </TitledListItem>
          )}
          {info?.luggageStorage && (
            <TitledListItem title={info.luggageStorage.label}>
              <p>{info.luggageStorage.description}</p>
            </TitledListItem>
          )}
          {info?.cancellationPrepayment && (
            <TitledListItem title={info.cancellationPrepayment.label}>
              <p>{info.cancellationPrepayment.description}</p>
            </TitledListItem>
          )}
          {!!info?.paymentMethods?.list?.length && (
            <TitledListItem title={info?.paymentMethods.label}>
              <ul>
                {info.paymentMethods.list.map((el, i) => (<li key={i}>{el}</li>))}
              </ul>
            </TitledListItem>
          )}
        </ul>
      )}
    </div>
  )
}

ArrivalAndDepartureSection.propTypes = {
  data: PropTypes.any
}

export default ArrivalAndDepartureSection;
